export function integrationLocationOptionValue (loc) {
  if (!loc) return null
  if (loc.true_id != null && loc.true_id !== '') return loc.true_id
  if (loc._integrationLocationId != null && loc._integrationLocationId !== '') {
    return loc._integrationLocationId
  }
  return null
}

export function resolveLocationTrueId (locations, value) {
  if (value == null || value === '') return null
  const list = Array.isArray(locations) ? locations : []
  const loc = list.find((entry) => {
    const candidates = [
      entry.true_id,
      entry._integrationLocationId,
      entry.id,
      entry.location_id,
      entry._id
    ]
    return candidates.some(v => v != null && v !== '' && String(v) === String(value))
  })
  if (loc && loc.true_id != null && loc.true_id !== '') {
    return loc.true_id
  }
  return value
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Integrations/integrationLocationHelpers.js